export default "__VITE_ASSET__BMfmXKI$__"